import React, { Component } from "react";
// import { required, length, email } from "../../util/validators";
import Auth from "./auth";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Input from "../../components/form/input/input";
import Button from "../../components/button/button";
function Login(props) {
  const [state, setState] = useState({
    loginForm: {
      email: {
        value: "",
        // valid: false,
        // touched: false,
        // validators: [required, email],
      },
      password: {
        value: "",
        // valid: false,
        // touched: false,
        // validators: [required, length({ min: 5 })],
      },
      // formIsValid: false,
    },
  });

  const navigate = useNavigate();
  const submitHandler = async (e) => {
    const login = await props.onLogin(e, {
      email: state.loginForm.email.value,
      password: state.loginForm.password.value,
    });
    if (login) {
      navigate("/");
    }
  };
  const inputChangeHandler = (input, value) => {
    setState((prevState) => {
      let isValid = true;
      // for (const validator of prevState.loginForm[input].validators) {
      //   isValid = isValid && validator(value);
      // }
      const updatedForm = {
        ...prevState.loginForm,
        [input]: {
          ...prevState.loginForm[input],
          // valid: isValid,
          value: value,
        },
      };
      // let formIsValid = true;
      // for (const inputName in updatedForm) {
      //   formIsValid = formIsValid && updatedForm[inputName].valid;
      // }
      return {
        loginForm: updatedForm,
        // formIsValid: formIsValid,
      };
    });
  };

  // inputBlurHandler = (input) => {
  //   setState((prevState) => {
  //     return {
  //       loginForm: {
  //         ...prevState.loginForm,
  //         [input]: {
  //           ...prevState.loginForm[input],
  //           touched: true,
  //         },
  //       },
  //     };
  //   });
  // };

  return (
    <Auth>
      <form onSubmit={submitHandler}>
        <Input
          id="email"
          label="Your E-Mail"
          type="email"
          control="input"
          onChange={inputChangeHandler}
          // onBlur={props.inputBlurHandler.bind(props, "email")}
          value={state.loginForm["email"].value}
          // valid={state.loginForm["email"].valid}
          // touched={state.loginForm["email"].touched}
        />
        <Input
          id="password"
          label="Password"
          type="password"
          control="input"
          onChange={inputChangeHandler}
          // onBlur={props.inputBlurHandler.bind(props, "password")}
          value={state.loginForm["password"].value}
          // valid={state.loginForm["password"].valid}
          // touched={state.loginForm["password"].touched}
        />
        <Button design="raised" type="submit" loading={props.loading}>
          Login
        </Button>
      </form>
    </Auth>
  );
}

export default Login;
